import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { withOnMountHandler } from "../../../../../../../../utils/withOnMountHandler";
import { Modal as _Modal } from "./Modal";
export var Modal = compose(withDataConverter(function (props) {
  var _props$onMount;
  return {
    src: props.qr.url,
    backButtonProps: {
      onClick: props.onClose,
      disabled: false,
      children: ''
    },
    title: props.title,
    subtitle: props.description,
    onMount: (_props$onMount = props.onMount) !== null && _props$onMount !== void 0 ? _props$onMount : function () {}
  };
}),
//
withOnMountHandler)(_Modal);